// Travel IQ: intro → one question at a time with instant feedback → result.
import { $, $$, readJSON, t } from "./dom.js";
import { swapIn } from "../motion.js";

export function initQuiz() {
  const body = $(".js-quiz");
  const quiz = readJSON(".js-quiz-data");
  if (!body || !quiz || !quiz.length) return;

  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
  let index = 0;
  let score = 0;
  let phase = "intro";

  const intro = () => {
    body.innerHTML = '<div class="quiz__intro"><p class="quiz__lead">' + esc(body.dataset.lead || "") + '</p><button type="button" class="btn btn--accent" data-start>' + esc(t("start")) + "</button></div>";
    $("[data-start]", body).onclick = () => {
      phase = "question";
      index = 0;
      score = 0;
      render();
    };
  };

  const question = () => {
    const item = quiz[index];
    body.innerHTML =
      '<div class="quiz__progress"><div class="track"><div class="fill" style="width:' + (index / quiz.length) * 100 + '%"></div></div><span class="lbl">' + (index + 1) + " / " + quiz.length + "</span></div>" +
      '<h3 class="quiz__q">' + esc(item.q) + '</h3><div class="quiz__opts">' +
      item.opts.map((o, i) => '<button type="button" class="quiz__opt" data-i="' + i + '"><span class="mark">' + String.fromCharCode(65 + i) + "</span><span>" + esc(o) + "</span></button>").join("") +
      '</div><div class="js-quiz-after"></div>';
    $$(".quiz__opt", body).forEach((btn) => (btn.onclick = () => answer(Number(btn.dataset.i))));
  };

  const answer = (i) => {
    const item = quiz[index];
    $$(".quiz__opt", body).forEach((btn) => {
      const bi = Number(btn.dataset.i);
      btn.disabled = true;
      if (bi === item.a) btn.classList.add("is-correct");
      else if (bi === i) btn.classList.add("is-wrong");
    });
    if (i === item.a) score++;
    const last = index === quiz.length - 1;
    // item.why is sanitised server-side (wp_kses: b/strong/em/i only).
    const after = $(".js-quiz-after", body);
    after.innerHTML =
      '<div class="quiz__why"><b>' + esc(i === item.a ? t("correct") : t("notQuite")) + "</b> " + item.why + '</div><div class="quiz__foot"><button type="button" class="btn btn--accent" data-next>' + esc(last ? t("results") : t("next")) + "</button></div>";
    swapIn(Array.from(after.children), { y: 14, stagger: 0.08, duration: 0.4 });
    const fill = $(".quiz__progress .fill", body);
    if (fill) fill.style.width = ((index + 1) / quiz.length) * 100 + "%";
    $("[data-next]", body).onclick = () => {
      if (last) phase = "result";
      else index++;
      render();
    };
  };

  const result = () => {
    const tiers = (window.wpsData && window.wpsData.i18n.tiers) || {};
    const pick = score === quiz.length ? tiers.perfect : score >= 4 ? tiers.high : score >= 2 ? tiers.mid : tiers.low;
    const [tier, line] = pick || ["", ""];
    body.innerHTML =
      '<div class="quiz__result"><div class="quiz__score"><b>' + score + "</b> / " + quiz.length + '</div><div class="quiz__tier">' + esc(tier) + "</div><p>" + esc(line) + "</p>" +
      '<div class="quiz__actions"><button type="button" class="btn btn--accent" data-again>' + esc(t("again")) + "</button>" +
      (body.dataset.archive ? '<a class="btn btn--ghost" href="' + esc(body.dataset.archive) + '">' + esc(t("readStories")) + "</a>" : "") + "</div></div>";
    $("[data-again]", body).onclick = () => {
      phase = "intro";
      render();
    };
  };

  function render() {
    if (phase === "intro") intro();
    else if (phase === "question") question();
    else result();
    swapIn(phase === "question" ? [$(".quiz__q", body), ...$$(".quiz__opt", body)] : Array.from(body.firstElementChild ? body.firstElementChild.children : []), { y: 18, stagger: 0.06 });
  }
  render();
}
